/** @public */
export enum NameFormat {
  PROFESSIONAL = 'professional',
  PROFESSIONAL_SHORT = 'professional_short',
  NATURAL = 'natural',
  FILE = 'file',
  FIRST_ONLY = 'first_only',
  POSSESSIVE = 'possessive',
  INITIALS = 'initials',
}

export function formatName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  format: NameFormat = NameFormat.PROFESSIONAL,
): string {
  const first = firstName?.trim() || '';
  const last = lastName?.trim() || '';

  if (!first && !last) return '';

  switch (format) {
    case NameFormat.PROFESSIONAL:
      if (!last) return first;
      if (!first) return last;
      return `${last}, ${first}`;

    case NameFormat.PROFESSIONAL_SHORT:
      if (!last) return first;
      if (!first) return last;
      return `${last}, ${first.charAt(0)}`;

    case NameFormat.NATURAL:
      return [first, last].filter(Boolean).join(' ');

    case NameFormat.FILE:
      if (!last) return first;
      if (!first) return last;
      return `${last}_${first}`;

    case NameFormat.FIRST_ONLY:
      return first;

    case NameFormat.POSSESSIVE:
      if (!first) return '';
      return first.endsWith('s') ? `${first}'` : `${first}'s`;

    case NameFormat.INITIALS: {
      const firstInitial = first.charAt(0).toUpperCase();
      const lastInitial = last.charAt(0).toUpperCase();
      return `${firstInitial}${lastInitial}`;
    }

    default:
      return '';
  }
}
